import type { FC } from 'react';
import FolderBar, { Props } from '../';
import StickyBar from '../../StickyBar';

export const StickyFolderBar: FC<Props> = props => (
  <StickyBar>{() => <FolderBar {...props} />}</StickyBar>
);
StickyFolderBar.displayName = 'StickyFolderBar';

export default StickyFolderBar;
